import env from "../utils/env";
import { prepareHyHttpHeaders } from "../utils/http";

export function stringifySearchParams(searchParams) {
  return new URLSearchParams(searchParams).toString();
}

export function createAbortableFetcher(url, config) {
  let abortController;
  function doFetch(searchParams) {
    if (abortController) {
      abortController.abort();
    }
    abortController = new AbortController();
    let finalUrl = url;
    if (searchParams) {
      finalUrl += "?";
      if (typeof searchParams === "string") finalUrl += searchParams;
      if (typeof searchParams === "object")
        finalUrl += stringifySearchParams(searchParams);
    }
    return fetch(finalUrl, { ...config, signal: abortController.signal })
      .then(res => res.json())
      .catch(() => {});
  }
  function abortFetch() {
    abortController.abort();
  }
  return [doFetch, abortFetch];
}

export function createPricePrescriptionsFetcher() {
  const [doFetch] = createAbortableFetcher(
    `${env("BASE_HY_URL")}rx/details/price`,
    { headers: prepareHyHttpHeaders() }
  );
  return function fetchPricePrescriptions(searchParams) {
    return doFetch(searchParams);
  };
}

export function createDiscountCardFetcher() {
  const [doFetch] = createAbortableFetcher(
    `${env("BASE_HY_URL")}rx/discount-card`,
    { headers: prepareHyHttpHeaders() }
  );
  return function fetchDiscountCard(providerId) {
    return doFetch({ providerId });
  };
}

export async function emailDiscountCard(payload) {
  const res = await fetch(
    `${env("BASE_HY_URL")}profiles/${payload.profileId}/discount-card/email`,
    {
      method: "POST",
      headers: prepareHyHttpHeaders(),
      body: JSON.stringify(payload)
    }
  );
  return res.json();
}
